import { Formik } from 'formik';
import { useParams } from 'react-router-dom';
import { AppInput, AppRemixIcon } from '@/layout/AppComponents';
import AppLink from '@/routing/helpers/AppLink';
import Translator from '@/layout/components/helpers/Translator';

export default function SiemensUserAccessCode({
  loginValidationSchema,
  showBtnCheckCode,
  showBtnDownloadDocument,
  showBtnSignUpCode,
  isSignUp,
  message,
  error,
  onHandleSubmission,
  onHandleLogin,
}) {
  const { client } = useParams();

  return (
    <div className="user-access-code-login">
      <img className="img-responsive" src="/images/client/siemens/siemens-logo.png" />
      <h1>Toma de datos de puestos de trabajo</h1>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 signup-block mb-5">
            <Formik
              initialValues={{
                code: '',
                password: '',
                passwordConfirm: '',
              }}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={onHandleSubmission}
            >
              {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                  {isSignUp ? (
                    <div className="signup-success-wrapper alert-success">
                      <AppRemixIcon icon="check" />
                      <div>¡Usuario registrado con éxito!</div>
                    </div>
                  ) : (
                    <div className="signup-wrapper">
                      <label>¿Eres nuevo? Introduce tu GID</label>
                      <br />
                      <span>
                        En caso de tener problemas de acceso contacte con{' '}
                        <a href="mailto:info@worldlex.net">info@worldlex.net</a>
                      </span>
                      <AppInput
                        title="Código de usuario"
                        value={values.code}
                        error={errors.code}
                        onChange={(v) => setFieldValue('code', v)}
                      />
                      {showBtnSignUpCode && (
                        <>
                          <AppInput
                            title="Contraseña"
                            value={values.password}
                            error={errors.password}
                            onChange={(v) => setFieldValue('password', v)}
                            isPassword
                          />
                          <AppInput
                            title="Confirmar contraseña"
                            value={values.passwordConfirm}
                            error={errors.passwordConfirm}
                            onChange={(v) => setFieldValue('passwordConfirm', v)}
                            isPassword
                          />
                        </>
                      )}
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={isSubmitting}
                      >
                        {showBtnCheckCode && 'Comprobar código'}
                        {showBtnDownloadDocument && 'Descargar manual'}
                        {showBtnSignUpCode && 'Registrar código'}
                      </button>
                    </div>
                  )}
                </form>
              )}
            </Formik>
          </div>
          <div className="col-12 col-md-6">
            <label>Acceso</label>
            <Formik
              initialValues={{
                username: '',
                password: '',
              }}
              validateOnChange={false}
              validateOnBlur={false}
              validationSchema={loginValidationSchema}
              onSubmit={onHandleLogin}
            >
              {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                  <AppInput
                    title="Código de usuario"
                    value={values.username}
                    error={errors.username}
                    onChange={(v) => setFieldValue('username', v)}
                    autoFocus
                  />
                  <AppInput
                    title="Password"
                    value={values.password}
                    error={errors.password}
                    onChange={(v) => setFieldValue('password', v)}
                    isPassword
                  />
                  <button
                    type="submit"
                    id="btn-login"
                    name="login"
                    className="btn btn-primary  w-100"
                    disabled={isSubmitting}
                  >
                    Acceder
                  </button>
                  {error && <div className="alert alert-danger mt-3">{error}</div>}
                  <AppLink
                    path="user_access_code_remember_password"
                    params={{ client }}
                  >
                    <Translator file="user" name="user.password.forgotten" />
                  </AppLink>
                </form>
              )}
            </Formik>
            <div className="mt-2">
              <i>
                <b>
                  Si tienes problema con el usuario o con la contraseña, por favor
                  contacta con info@worldlex.net
                </b>
              </i>
            </div>

            <div className="mt-2">
              <i>
                *Protección de Datos: En esta plataforma no se registrarán datos
                personales de ningún tipo.
              </i>
            </div>
          </div>
        </div>
        {message && (
          <div className="row">
            <div className="col-12 mt-3">
              <div id="message" className="alert alert-danger">
                {message}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
